<ngx-spinner bdColor="rgba(51,51,51,0.55)" size="medium" color="#fff" type="line-spin-clockwise-fade"
    [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="col-12">
    <h2 class="page-title" tabindex="0">{{'breadcrumb.view-alert' | translate}}</h2>
    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
            <span *ngIf="breadcrumb">{{ 'breadcrumb.' + breadcrumb | translate }}</span>
        </ng-container>
    </xng-breadcrumb>
    <div *ngIf="selectedAlert">
        <div class="row float-right" *ngxPermissionsOnly="['Owner', 'SecurityAgent', 'Supervisor']">
            <div class="col-12">
                <div class="d-flex flex-row bd-highlight">
                    <div class="bd-highlight mr-2"
                        *ngIf="(alertService.alertStatus==2||alertService.alertStatus==4)&&(selectedAlert['createdBy']!=userId&&!expired)">
                        <ng-template [ngxPermissionsOnly]="['Owner','Supervisor']">
                            <button [id]="'reassign_alert#' + selectedAlert.id" type="button"
                                class="btn btn-black btn-h-black" (click)="reassignAlert()"
                                title="{{'alert.reassign_alert' | translate}}">
                                {{'alert.reassign_alert' | translate}}
                            </button>
                        </ng-template>
                    </div>
                    <div class="bd-highlight"
                        *ngIf="attending&&((alertService.alertStatus!=1)&&(selectedAlert['createdBy']!=userId)&&!expired)">
                        <div class="dropdown" ngbDropdown placement="bottom-right">
                            <button ngbDropdownToggle
                                class="btn btn-blue btn-h-blue dropdown-toggle">{{'alert.close_alert' | translate}} <i
                                    class="fa fa-caret-down"></i></button>
                            <div ngbDropdownMenu class="dropdown-menu">
                                <button ngbDropdownItem [id]="'attended#' + selectedAlert.id"
                                    (click)="confirmClosePrompt('attended')" title="{{'alert.attended' | translate}}">
                                    {{'alert.attended' | translate}}</button>
                                <button ngbDropdownItem [id]="'false_alert#' + selectedAlert.id"
                                    (click)="confirmClosePrompt('false_alert')"
                                    title="{{'alert.false_alert' | translate}}">{{'alert.false_alert' |
                                    translate}}</button>
                                <button ngbDropdownItem *ngIf="selectedAlert['inGeofence']!=2"
                                    [id]="'outZone#' + selectedAlert.id" (click)="confirmClosePrompt('out_of_zone')"
                                    title="{{'alert.out_of_zone' | translate}}">{{'alert.out_of_zone' |
                                    translate}}</button>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="bd-highlight"
                        *ngIf="!attending&&(selectedAlert['inGeofence']!=2)&&((alertService.alertStatus==0||alertService.alertStatus==7)&&(selectedAlert['createdBy']!=userId)&&!expired)">
                        <button type="button" class="btn btn-black btn-h-black mr-2"
                            (click)="confirmClosePrompt('mark_out_zone')">
                            {{'alert.mark_out_zone' | translate}}
                        </button>
                    </div> -->
                    <div class="bd-highlight"
                        *ngIf="!attending&&((alertService.alertStatus==0||alertService.alertStatus==7)&&(selectedAlert['createdBy']!=userId)&&!expired)">
                        <button [id]="'attend#' + selectedAlert.id" type="button" class="btn btn-blue btn-h-blue"
                            (click)="attendAlert('pr')">
                            {{'alert.attend' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <br><br>
        <div class="row">
            <div class="col-xs-12 col-lg-6">
                <div class="card border-top scroll">
                    <div class="col-12 mb-3">
                        <div class="row">
                            <div class="col-6">
                                <h5 class="mt-3 mb-0">{{'general.alert' | translate}} #{{selectedAlert.id}}</h5>
                            </div>
                            <div class="col-6 text-right mt-3">
                                <strong>
                                    <span *ngIf="selectedAlert['inGeofence']==0"
                                        class="btn-orange p-1">{{'alert.out-of-zone' | translate}}</span>
                                    <span
                                        *ngIf="((((lateTimer > selectedAlert.attendMilliseconds && selectedAlert.attendMilliseconds && (alertService.alertStatus != 2 && alertService.alertStatus != 4)) ||
                                    (lateTimer > selectedAlert.closeMilliseconds && selectedAlert.closeMilliseconds) || (lateTimer > selectedAlert.closeMilliseconds &&
                                    selectedAlert.closeMilliseconds > selectedAlert.attendMilliseconds && (selectedAlert.attendMilliseconds &&
                                    selectedAlert.closeMilliseconds)) || (selectedAlert.late && selectedAlert.late == 'True')) && alertService.alertStatus != 3) || (unattendedLateCanceled && selectedAlert.attendMilliseconds))"
                                        class="btn-red p-1 ml-1">{{'alert.late_tag' | translate}}</span></strong>
                            </div>
                        </div>
                        <hr>
                        <div class="text-center"><img class="user-picture"
                                [src]="profile['userPhoto'] ? profile['userPhoto'] : 'assets/images/default-user.jpeg'"
                                alt="{{selectedAlert['createdByName']}}" width="100" height="100"><br></div>

                        <div class="row">
                            <div class="col-6 pr-0"
                                *ngIf="attending&&(alertService.alertStatus!=1&&alertService.alertStatus!=3)&&!functionsService.isExpired()">
                                <label for="alertType"><strong>{{'alert.alert_type' | translate}}: </strong></label>
                            </div>
                            <div class="col-6 pl-0" *ngIf="attending&&(alertService.alertStatus!=1&&alertService.alertStatus!=3)&&!functionsService.isExpired()">
                                <div *ngIf="alertTypes.length > 1; else singleAlert">
                                    <select class="form-control mb-10" id="alertType" name="alertType" (change)="changeType($event)">
                                        <option *ngFor="let alert of alertTypes" 
                                            [value]="alert.id"
                                            [selected]="selectedAlert.alertTypeName === alert.name">
                                            {{ alert.name }}
                                        </option>
                                    </select>
                                </div>
                                <ng-template #singleAlert>
                                    <label for="">{{ alertTypes[0].name }}</label>
                                </ng-template>
                            </div>
                            <div class="col-6 pr-0"
                                *ngIf="!attending||alertService.alertStatus==3||functionsService.isExpired()">
                                <strong>{{'alert.alert_type' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0"
                                *ngIf="(!attending||alertService.alertStatus==3||functionsService.isExpired()) && selectedAlert">
                                {{ selectedAlert.alertTypeName }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.timer' | translate}}: </strong>
                            </div>
                            <div *ngIf="(((!selectedAlert.attendTime && !selectedAlert.closeTime) || ((selectedAlert.attendMilliseconds > lateTimer 
                                && selectedAlert.attendMilliseconds) || (!selectedAlert.closeMilliseconds && 
                                (alertService.alertStatus == 2 || alertService.alertStatus == 4)) || (selectedAlert.closeMilliseconds > lateTimer) 
                                || (!selectedAlert.attendMilliseconds && (alertService.alertStatus != 2 && alertService.alertStatus != 4)) ||
                                (selectedAlert.closeMilliseconds > lateTimer && selectedAlert.attendMilliseconds > selectedAlert.closeMilliseconds)) || 
                                alertService.alertStatus == 3 && !unattendedLateCanceled) && ((!selectedAlert.late || selectedAlert.late == 'False') || (alertService.alertStatus == 3 && !unattendedLateCanceled)))"
                                class="col-6 pl-0">
                                <span *ngIf="days&&days>0">{{days}} {{'general.days'| translate}}</span> {{totalTime}}
                            </div>
                            <div *ngIf="((((lateTimer > selectedAlert.attendMilliseconds && selectedAlert.attendMilliseconds && (alertService.alertStatus != 2 && alertService.alertStatus != 4)) || 
                                (lateTimer > selectedAlert.closeMilliseconds && selectedAlert.closeMilliseconds) || (lateTimer > selectedAlert.closeMilliseconds && 
                                selectedAlert.closeMilliseconds > selectedAlert.attendMilliseconds && (selectedAlert.attendMilliseconds && 
                                selectedAlert.closeMilliseconds)) || (selectedAlert.late && selectedAlert.late == 'True')) && alertService.alertStatus != 3) || (unattendedLateCanceled && selectedAlert.attendMilliseconds))"
                                class="col-6 pl-0 error">
                                <span *ngIf="days&&days>0">{{days}} {{'general.days'| translate}}</span> {{totalTime}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.time_attend' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert["attendTime"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.time_close' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert["closeTime"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.triggered_by' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert.createdByName}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.triggered_on' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ functionsService.convertUTCDateToLocalDate(selectedAlert.createdDate) }}
                            </div>
                        </div>
                        <div *ngIf="selectedAlert['attendedDate'] && (selectedAlert['Status']==2||selectedAlert['Status']==4)"
                            class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.attended_by' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert.attendedByName}}
                            </div>
                        </div>
                        <div *ngIf="selectedAlert['attendedDate'] && (selectedAlert['Status']==2||selectedAlert['Status']==4)"
                            class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.attended_on' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ functionsService.convertUTCDateToLocalDate(selectedAlert.attendedDate) }}
                            </div>
                        </div>
                        <div *ngIf="alertService.canceledDate" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.canceled_on' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ functionsService.convertUTCDateToLocalDate(alertService.canceledDate) }}
                            </div>
                        </div>
                        <div *ngIf="selectedAlert['closedDate']" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.closed_on' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ functionsService.convertUTCDateToLocalDate(selectedAlert.closedDate) }}
                            </div>
                        </div>
                        <div *ngIf="geoAssignment" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.assigned_zone' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ selectedAlert.agentZoneName?
                                selectedAlert.agentZoneName:selectedAlert.initialZoneName?selectedAlert.initialZoneName:""
                                }}
                            </div>
                        </div>
                        <div *ngIf="selectedAlert['userGroups']" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.user_groups' | translate}}</strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ selectedAlert.userGroups }}
                            </div>
                        </div>
                        <hr>
                        <span class="dark-gray-text uppercase"><strong>{{'general.user_information' |
                                translate}}</strong></span>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.name' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert["createdByName"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.phone_number' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["phoneNumber"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.res_phone_number' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["phoneNumberResidence"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.dob' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["dob"]?this.functionsService.convertUTCDateToLocalDateOnly(profile["dob"]+'T12:00:00'):''}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.gender' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["gender"]}}
                            </div>
                        </div>
                                                <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.children' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["children"]}}
                            </div>
                        </div>
                                                <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.motor_vehicle' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["motor_vehicle"]}}
                            </div>
                        </div>
                                                <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.odim' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["odim"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.address' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["fullAddress"]}}
                            </div>
                        </div>
                        <hr>
                        <span class="dark-gray-text uppercase"><strong>{{'user.primary_contact' |
                                translate}}</strong></span>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.name' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["primaryContactName"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.phone_number' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["primaryContactPhoneNumber"]}}
                            </div>
                        </div>
                        <hr>
                        <span class="dark-gray-text uppercase"><strong>{{'user.secondary_contact' |
                                translate}}</strong></span>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.name' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["secondaryContactName"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.phone_number' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["secondaryContactPhoneNumber"]}}
                            </div>
                        </div>
                        <hr>
                        <div *ngIf="aggressors && aggressors.length > 0">
                            <span class="dark-gray-text uppercase"><strong>{{'aggressor.list_title' |
                                    translate}}</strong></span>

                            <!-- Loop through aggressors -->
                            <div *ngFor="let aggressor of aggressors; let idx = index" class="row">
                                <div class="col-6 pr-0">
                                    <strong>{{ aggressor.aggressorName }}</strong>
                                </div>
                                <div class="col-6 pl-0 text-right">
                                    <button type="button" class="btn btn-sm btn-link p-0"
                                        (click)="openAggressorModal(aggressor)"
                                        [title]="'aggressor.view_details' | translate">
                                        <i class="fa fa-eye text-primary"></i>
                                    </button>
                                </div>
                            </div>
                            <hr>
                        </div>

                        <!-- No aggressors message -->
                        <div *ngIf="!aggressors || aggressors.length === 0">
                            <span class="dark-gray-text uppercase"><strong>{{'aggressor.list_title' |
                                    translate}}</strong></span>
                            <div class="row">
                                <div class="col-12 text-muted text-center py-2">
                                    <small>{{'aggressor.no_aggressors' | translate}}</small>
                                </div>
                            </div>
                            <hr>
                        </div>
                        <div *ngIf="fieldOption">
                            <span class="dark-gray-text uppercase"><strong>{{'setting.additional_info' |
                                    translate}}</strong></span>
                            <div *ngFor="let fields of c_fields" class="row">
                                <div class="col-6 pr-0">
                                    <strong>{{ fields.field }}: </strong>
                                </div>
                                <div class="col-6 pl-0">
                                    {{ fields.fieldValue }}
                                </div>
                            </div>
                            <hr>
                        </div>
                        <span class="dark-gray-text uppercase"><strong>{{'general.documents' |
                                translate}}</strong></span>
                        <div class="row">
                            <div class="col-12">
                                <ul>
                                    <li *ngFor="let document of documents"><a tabindex="0"
                                            (keydown.enter)="previewPDF(document)" (click)="previewPDF(document)"
                                            class="custom-hyperlink"><strong>{{ document.name }}<span
                                                    class="screen-reader-only">({{'general.opens_new_tab' |
                                                    translate}})</span>
                                                <i *ngIf="document.name.slice(-3) == 'pdf'"
                                                    class="fa fa-external-link ml-2" aria-hidden="true"></i>
                                            </strong></a></li>
                                </ul>
                            </div>
                        </div>
                        <div id="alert-log" hidden>
                            <hr>
                            <div class="row">
                                <div class="col-12">
                                    <a tabindex="0" (keydown.enter)="viewAlertLog(selectedAlert.id)"
                                        (click)="viewAlertLog(selectedAlert.id)"
                                        class="custom-hyperlink"><strong>{{'alert.view_log' | translate}}<span
                                                class="screen-reader-only">({{'general.opens_new_tab' |
                                                translate}})</span><i class="fa fa-external-link ml-2"
                                                aria-hidden="true"></i></strong></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-lg-6">
                <div class="col-12 p-0" *ngIf="selectedAlert">
                    <span>
                        <strong>{{'alert.initial_latitude' | translate}}:</strong> {{selectedAlert.initialLatitude}}
                        <strong>{{'alert.initial_longitude' | translate}}:</strong> {{selectedAlert.initialLongitude}}
                        <br>
                    </span>
                    <span
                        *ngIf="(alertService.alertStatus==3 || alertService.alertStatus==4) && (finalLatitude && finalLongitude)">
                        <strong>{{'alert.final_latitude' | translate}}: </strong><span>{{finalLatitude}}</span>&nbsp;
                        <strong>{{'alert.final_longitude' | translate}}: </strong><span>{{finalLongitude}}</span><br>
                    </span>
                </div>
                <div class="col-12 p-0">
                    <div [id]="'mapAlert#'+selectedAlert.id" class="map-style"></div>
                    <div class="row pt-1">
                        <div
                            [ngClass]="((alertService.alertStatus==3 || alertService.alertStatus==4) && (finalLatitude && finalLongitude))? 'col-4': 'col-6'">
                            <strong>{{'roles.User' | translate}}</strong>
                            <ul class="legend">
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/blue-dot.png">
                                    {{'alert.previous_position' | translate}}</li>
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/green-dot.png">
                                    {{'alert.current_position' | translate}}</li>
                            </ul>
                        </div>
                        <div
                            [ngClass]="((alertService.alertStatus==3 || alertService.alertStatus==4) && (finalLatitude && finalLongitude))? 'col-4': 'col-6'">
                            <strong>{{'roles.SecurityAgent' | translate}}</strong>
                            <ul class="legend">
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/yellow-dot.png">
                                    {{'alert.previous_position' | translate}}</li>
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/orange-dot.png">
                                    {{'alert.current_position' | translate}}</li>
                            </ul>
                        </div>
                        <div *ngIf="(alertService.alertStatus==3 || alertService.alertStatus==4) && (finalLatitude && finalLongitude)"
                            class="col-4">
                            <strong>{{'general.alert' | translate}}</strong>
                            <ul class="legend">
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/red-dot.png">
                                    {{'alert.final_position' | translate}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <br>
            </div>
        </div>
        <div class="row pb-4">
            <div class="col-12">
                <div class="card border-top">
                    <div class="pl-3 pr-3">
                        <h5 class="mt-3 mb-0">{{'general.conversation' | translate}}</h5>
                        <hr class="mb-0">
                    </div>
                    <div class="messaging">
                        <div class="bg-white">
                            <div class="mesgs">
                                <div #msg_history class="msg_history" [scrollTop]="msg_history.scrollHeight">
                                    <ng-container *ngFor="let d of chatMessages; let index=index;">
                                        <div *ngIf="(d.senderId === alertCreatedBy)">
                                            <div class="incoming_msg">
                                                <div class="received_msg">
                                                    <div class="received_withd_msg">
                                                        <span class="time_date" *ngIf="d.contentType !== 3">{{
                                                            selectedAlert.createdByName }}</span>
                                                        <p class="text-break" *ngIf="d.contentType === 0">{{ d.message
                                                            }}</p>
                                                        <a *ngIf="d.contentType === 1"
                                                            (click)="functionsService.openImage(d.profilePicLink)"><img
                                                                [src]="d.profilePicLink" [alt]="d.profilePicLink"
                                                                class="rounded img-chat" /></a>
                                                        <div *ngIf="d.contentType === 2" [id]="d.id"
                                                            class="rounded h-150" [chatLocation]="d.content"></div>
                                                        <span class="time_date" *ngIf="d.contentType !== 3">{{
                                                            d.timestamp | date: 'MM/dd/yyyy | h:mm:ss a' }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="(d.senderId !== alertCreatedBy.toString()) && (d.senderId !== selectedAlert.attendedBy.toString())">
                                            <div class="outgoing_msg">
                                                <div class="sent_msg">
                                                    <span class="time_date"
                                                        *ngIf="d.contentType !== 3 && !d.senderName">{{
                                                        'general.representative' | translate}} #{{d.ownerID}} </span>
                                                    <span class="time_date"
                                                        *ngIf="d.contentType !== 3 && d.senderName">{{d.senderName}}
                                                    </span>
                                                    <p class="text-break" *ngIf="d.contentType === 0">{{ d.message }}
                                                    </p>
                                                    <a *ngIf="d.contentType === 1"
                                                        (click)="functionsService.openImage(d.profilePicLink)"><img
                                                            [src]="d.profilePicLink" [alt]="d.profilePicLink"
                                                            class="rounded img-chat" /></a>
                                                    <div *ngIf="d.contentType === 2" [id]="d.id" class="rounded h-150"
                                                        [chatLocation]="d.content"></div>
                                                    <span class="time_date" *ngIf="d.contentType !== 3">{{ d.timestamp |
                                                        date: 'MM/dd/yyyy | h:mm:ss
                                                        a'}}<!---{{ d.timestamp.seconds*1000 | date: 'MM/dd/yyyy | h:mm:ss a z' }}---></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="(d.senderId !== alertCreatedBy) && (d.senderId === selectedAlert.attendedBy.toString())">
                                            <div class="outgoing_msg">
                                                <div class="sent_msg">
                                                    <span class="time_date" *ngIf="d.contentType !== 3">{{
                                                        selectedAlert.attendedByName }}</span>
                                                    <p class="text-break" *ngIf="d.contentType === 0">{{ d.message }}
                                                    </p>
                                                    <a *ngIf="d.contentType === 1"
                                                        (click)="functionsService.openImage(d.profilePicLink)"><img
                                                            [src]="d.profilePicLink" [alt]="d.profilePicLink"
                                                            class="rounded img-chat" /></a>
                                                    <div *ngIf="d.contentType === 2" [id]="d.id" class="rounded h-150"
                                                        [chatLocation]="d.content"></div>
                                                    <span class="time_date" *ngIf="d.contentType !== 3">{{ d.timestamp |
                                                        date: 'MM/dd/yyyy | h:mm:ss
                                                        a'}}<!---{{ d.timestamp.seconds*1000 | date: 'MM/dd/yyyy | h:mm:ss a z' }}---></span>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <div *ngIf="chatMessages?.length == 0" class="dark-gray-text">
                                        <i>{{'alert.no_messages' | translate}}</i>
                                    </div>
                                </div>
                                <ng-template [ngxPermissionsOnly]="['Owner', 'SecurityAgent', 'Supervisor']">
                                    <div *ngIf="(attending)&&(alertService.alertStatus==2)&&!expired" class="type_msg">
                                        <div class="input_msg_write">
                                            <div class="row"
                                                *ngxPermissionsOnly="['Owner', 'SecurityAgent', 'Supervisor']">
                                                <div class="col-12">
                                                    <div class="d-flex bd-highlight">
                                                        <div class="bd-highlight flex-grow-1">
                                                            <input class="w-100" type="text"
                                                                [id]="'write_msg#' + selectedAlert.id"
                                                                placeholder="{{'alert.type_message' | translate}}"
                                                                [(ngModel)]="user_msg" (keyup.enter)="sendMessage()">
                                                        </div>
                                                        <div class="bd-highlight mr-2 mt-3">
                                                            <div class="dropdown" ngbDropdown placement="top-right">
                                                                <button ngbDropdownToggle
                                                                    title="{{'alert.select_pre_msg' | translate}}"
                                                                    class="bg-white border-0 p-0 text-primary dropdown-toggle mr-2"
                                                                    [id]="'msg_send_btn#' + selectedAlert.id"
                                                                    type="button">
                                                                    <i class="far fa-comment-alt p-1 img-round"
                                                                        aria-hidden="true"></i>
                                                                </button>
                                                                <div ngbDropdownMenu class="dropdown-menu">
                                                                    <div class="pl-3 pb-2">
                                                                        <strong>{{'setting.preconfigured_messages' |
                                                                            translate}}</strong></div>
                                                                    <hr class="m-0">
                                                                    <div *ngFor="let msg of messages">
                                                                        <button ngbDropdownItem
                                                                            class="pl-3 pr-3 pt-2 pb-2"
                                                                            (click)="addMessage(msg.message)">{{msg.message}}</button>
                                                                        <hr class="m-0">
                                                                    </div>
                                                                    <div *ngIf="msg_count==0"
                                                                        class="dark-gray-text pl-3">
                                                                        {{'alert.no_msg_avail' | translate}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="bd-highlight mt-3">
                                                            <button class="bg-white border-0 p-0 text-success"
                                                                title="{{'notification.send' | translate}}"
                                                                [id]="'msg_send_btn#' + selectedAlert.id" type="button"
                                                                (click)="sendMessage()">
                                                                <i class="fa fa-paper-plane-o p-1 img-round"
                                                                    aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Aggressor Details Modal -->
<ng-template #aggressorDetailsModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title dark-gray-text">
            <i class="fa fa-user"></i>
            {{ 'aggressor.information' | translate }}
        </h5>
        <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <!-- Aggressor Image -->
        <div class="row mb-3">
            <div class="col-12 text-center">
                <div class="aggressor-modal-image-container">
                    <img [src]="selectedAggressor?.imageUrl ? selectedAggressor?.imageUrl : 'assets/images/default-user.jpeg'"
                        [alt]="selectedAggressor?.aggressorName" class="img-round" width="100" height="100">
                    <!--(error)="onImageError($event)"-->
                </div>
            </div>
        </div>

        <!-- Aggressor Name -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.name' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.aggressorName }}
            </div>
        </div>

        <!-- Primary Address -->
        <div *ngIf="selectedAggressor?.aggressorPrimaryAddress" class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.primary_address' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.aggressorPrimaryAddress }}
            </div>
        </div>

        <!-- Secondary Address -->
        <div *ngIf="selectedAggressor?.aggressorSecondaryAddress" class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.secondary_address' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.aggressorSecondaryAddress }}
            </div>
        </div>

        <hr>

        <!-- Protection Order Details -->
        <span class="dark-gray-text uppercase"><strong>{{ 'aggressor.protection_order' | translate }}</strong></span>

        <!-- Order Number -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.order_number' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.protectionOrderNumber }}
            </div>
        </div>

        <!-- Start Date -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.start_date' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.protectionOrderStartDate | date:'MM/dd/yyyy' }}
            </div>
        </div>

        <!-- End Date -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.end_date' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.protectionOrderEndDate | date:'MM/dd/yyyy' }}
            </div>
        </div>

                <!-- Precint -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.precinct' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.precint }}
            </div>
        </div>

        <!-- Agent -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.agent' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.agent }}
            </div>
        </div>

        <!-- ODIM -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.restricted_area' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.restrictedArea }}
            </div>
        </div>

        <!-- Status -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.status' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                <span [ngClass]="{
                    'badge badge-success': selectedAggressor?.status === 1,
                    'badge badge-secondary': selectedAggressor?.status === 2,
                    'badge badge-warning': selectedAggressor?.status === 3,
                    'badge badge-danger': selectedAggressor?.status === 4,
                    'badge badge-info': selectedAggressor?.status === 5
                }">
                    {{ getStatusText(selectedAggressor?.status) }}
                </span>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-red btn-h-red mr-2 mb-2" (click)="modal.close()">
            {{ 'general.close' | translate }}
        </button>
    </div>
</ng-template>